
import React from "react"
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';

interface Props {
  title: string
  tooltip?: {
    formatter?: (items: any) => string
  }
  series: any[]
  xAxisData?: any[]
  xAxisLabelFormatter?: string
  yAxisLabelFormatter?: string
}

const WeeklyLineCard = (props: Props) => {

  const {
    title,
    tooltip,
    series,
    xAxisData,
    xAxisLabelFormatter,
    yAxisLabelFormatter,
  } = props

  const defTooltipFormatter = (items: any) => `${items[0].value}`

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: true
      },
      formatter: tooltip?.formatter ?? defTooltipFormatter
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData,
      axisLabel: {
        formatter: xAxisLabelFormatter
      },
    },
    yAxis: {
      axisLabel: {
        formatter: yAxisLabelFormatter
      },
      type: 'value'
    },
    series,
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className='card-title'>{title}</div>
        <ReactEChartsCore
          echarts={echarts}
          option={option}
        />
      </div>
    </div>
  )
}

export default WeeklyLineCard
